import { call } from "redux-saga/effects";

let createOneClickCQModule = null;
export function* createOneClickCQ({ data }) {
  try {
    if (!createOneClickCQModule) {
      createOneClickCQModule = yield call(() => import("./create-cq"));
    }
    yield call(createOneClickCQModule.createOneClickCQ, { data });
  } catch (error) {
    console.log(error);
  }
}

let confirmOneClickCQModule = null;
export function* confirmOneClickCQ({ data }) {
  try {
    if (!confirmOneClickCQModule) {
      confirmOneClickCQModule = yield call(() => import("./confirm-cq"));
    }
    yield call(confirmOneClickCQModule.confirmOneClickCQ, { data });
  } catch (error) {
    console.log(error);
  }
}

let deleteServiceByExpressOrderModule = null;
export function* deleteServiceByExpressOrder({ data }) {
  try {
    if (!deleteServiceByExpressOrderModule) {
      deleteServiceByExpressOrderModule = yield call(() =>
        import("./delete-service-by-express-order-module")
      );
    }
    yield call(deleteServiceByExpressOrderModule.deleteServiceByExpressOrder, {
      data,
    });
  } catch (error) {
    console.log(error);
  }
}
